import { useAtom } from "jotai";
import { atomFamily, atomWithStorage, useAtomValue } from "jotai/utils";

import * as flowConfig from "flows/time-series/config";

const PREFIX = `${flowConfig.FLOW_NAME}/create`;

const overlayToBeShown = atomWithStorage(`${PREFIX}/show-create-overlay`, true);

export const useOverlayStatus = () => useAtom(overlayToBeShown);

export const useGetOverlayDisplay = () => useAtomValue(overlayToBeShown);

const inputFile = atomWithStorage<string>(`${PREFIX}/input-file`, null);

export const useInputFile = () => useAtom(inputFile);

export const useGetInputFile = () => useAtomValue(inputFile);

const timeStamp = atomFamily((fileId: string) =>
  atomWithStorage<string>(`${PREFIX}/${fileId}/input-file`, null)
);

export const useTimestamp = (fileId: string) => useAtom(timeStamp(fileId));

export const useGetTimestamp = (fileId: string) =>
  useAtomValue(timeStamp(fileId));
